// Mirrors LanguageDetectionHandler::isBot() in
// Classes/Handler/LanguageDetectionHandler.php, which already suppresses the root country
// interstitial for crawlers. Keep the two patterns in sync.
//
// Deliberate divergence: the PHP pattern also matches Chrome-Lighthouse. Lighthouse is an
// auditing tool run on purpose, not a crawler - it must exercise exactly what a real visitor
// gets, background inertness included, or the accessibility audit measures the wrong thing.
const CRAWLER = /bot|google|baidu|bing|msn|teoma|slurp|yandex/i

export function isCrawler() {
  return CRAWLER.test(navigator.userAgent || '')
}
